import { createLoanAppConfig } from "@clcdev/gatsby-theme-application";
import meta from "./meta.js";

export default createLoanAppConfig(
    process.env.GATSBY_APP_CONFIG_VARIANT || "credit-classic",
    meta,
);